import { Radio } from "lucide-react";

import { usePessoasOnline } from "@/hooks/pessoa/use-pessoas-online";

import { PersonPresenceList } from "./PersonPresenceList";

export function PessoasOnlineList() {
  const { pessoas, loading } = usePessoasOnline();

  return (
    <PersonPresenceList
      icon={Radio}
      iconClassName="bg-emerald-500/10 text-emerald-600 dark:text-emerald-400"
      title="Online agora"
      pessoas={pessoas}
      loading={loading}
      emptyMessage="Ninguém ativo no sistema no momento."
      badge={{
        when: "naoVazio",
        content: (
          <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-emerald-500/15 px-2.5 py-1 font-mono text-[11px] font-medium text-emerald-600 ring-1 ring-inset ring-emerald-500/25 dark:text-emerald-400">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
            {pessoas.length}
          </span>
        ),
      }}
    />
  );
}
